import React from "react";
import { isFunction } from "lodash";

function getElementValue(e) {
    if (!e.currentTarget) {
        return "";
    }

    const type = e.currentTarget.type;
    switch (type) {
        case "checkbox":
            return e.currentTarget.checked;
        default:
            return e.currentTarget.value;
    }
}

export const updateFn = (fn) => {
    if (!fn || !isFunction(fn)) {
        return null;
    }

    return (e) => {
        const value = getElementValue(e);
        const name = e.currentTarget.name;

        return fn(name, value);
    };
};

export const WithOnClick = (WrappedInput) => {
    return class extends React.Component {
        updateField = (e) => {
            const value = getElementValue(e);
            const name = e.currentTarget.name || "";

            if (this.props.updateOnChange && isFunction(this.props.updateOnChange)) {
                this.props.updateOnChange(name, value);
            }
        };

        render() {
            return <WrappedInput {...this.props} onChange={() => {
            }} onClick={this.updateField} />;
        }
    };
};

export const UpdateStateInputs = (WrappedInput, updateState) => {
    return class extends React.Component {
        render() {
            return <WrappedInput {...this.props} updateOnChange={updateState} />;
        }
    };
};
